// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_d8335985","isDark":"rdg_be864f46"};